import { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updateSelectedStore } from '../redux/reducers/cartReducer';
import { cartStoreSelector } from '../redux/selectors/cartSelectors';
import { getActiveStoreId } from '../utils/getActiveStoreId';
import { NearbyStore } from '../types';

const useActiveStore = (_isKioskWelcome = false) => {
  const { selectedStore: activeStore } = useSelector(cartStoreSelector);
  const dispatch = useDispatch();
  const setActiveStore = (store) => dispatch(updateSelectedStore(store));

  return { activeStore: activeStore as NearbyStore, setActiveStore };
};

export const useActiveStoreId = () => {
  const { activeStore } = useActiveStore();
  return useMemo(() => activeStore ? getActiveStoreId(activeStore) : null, [activeStore]);
};

export default useActiveStore;
